import Api from '@/api/api'

export default {
    getProducts() {
        return Api.get('SaasAdmin/Product/GetProducts')
    },
    getPrductById(id) {
        return Api.get('SaasAdmin/Product/GetProduct/' + id)
    },
    addProduct(data) {
        return Api.post('SaasAdmin/Product/AddProduct', data)
    },
    updateProduct(id, data) {
        return Api.put('SaasAdmin/Product/UpdateProduct/' + id, data)
    },
    removeProduct(id) {
        return Api.delete('SaasAdmin/Product/DeleteProduct/' + id)
    }
}